export const NAME = 'CONSULTATION_SERVICE';

export const getConsultationService = (store) => store[NAME].fetch;
export const getConsultationServiceData = (store) => store[NAME].fetch.data;
export * from './bookings';
